import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const PasswordField = (props) => {
  const {
    password,
    className,
    autoFocus,
    ariaInvalid,
    ariaDescribedby,
    myRef
  } = props;
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const PasswordValidation = (e) => {
    const {
      target: { value }
    } = e;
    if (value.match(/^[a-zA-Z0-9!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]*$/)) {
      props.onChange(value);
    }
  };
  const disableCopy = (e) => {
    if((e.currentTarget.id === 'confirmPassWord' && (e.currentTarget.type === 'password' || e.currentTarget.type === 'text')) || (e.currentTarget.id === 'confirmPassword' && (e.currentTarget.type === 'password' || e.currentTarget.type === 'text'))){
          props.onCopy(e);
        }
  }
  const disablePaste = (e) => {
    if((e.currentTarget.id === 'confirmPassWord' && (e.currentTarget.type === 'password' || e.currentTarget.type === 'text')) || (e.currentTarget.id === 'confirmPassword' && (e.currentTarget.type === 'password' || e.currentTarget.type === 'text'))){
          props.onPaste(e);
        }
  }
  const HandleEnterKey = (e) => {
    if(e.keyCode === 13){
      setShowPassword(!showPassword)
    }
  }
  return (
    <div className="password-field">
      {ariaDescribedby ? (
        <Form.Control
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => PasswordValidation(e)}
          onBlur={(e) => {
            props.onBlur(e);
          }}
          className={className ? "error-input" : undefined}
          autoFocus={autoFocus}
          aria-required
          aria-invalid={ariaInvalid}
          aria-describedby={ariaDescribedby}
          ref={myRef}
          autoComplete="off"
          onCopy={(e) => disableCopy(e)}
          onPaste={(e) => disablePaste(e)}
        />
      ) : (
        <Form.Control
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => PasswordValidation(e)}
          onBlur={(e) => {
            props.onBlur(e);
          }}
          className={className ? "error-input" : undefined}
          autoFocus={autoFocus}
          aria-required
          autoComplete="off"
          onCopy={(e) => disableCopy(e)}
          onPaste={(e) => disablePaste(e)}
        />
      )}
      <span
        className={showPassword ? "eye-icon show" : "eye-icon"}
        tabIndex="0" aria-label={showPassword ? t("pages.login.hidePassword") : t("pages.login.showPassword")}
        onClick={() => setShowPassword(!showPassword)}
        onKeyDown={(e) => HandleEnterKey(e)}
        role="button"
      />
    </div>
  );
};

PasswordField.propTypes = {
  password: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  className: PropTypes.string,
  autoFocus: PropTypes.bool,
  ariaInvalid: PropTypes.bool,
  ariaDescribedby: PropTypes.string,
  myRef: PropTypes.object,
  onCopy: PropTypes.func,
  onPaste: PropTypes.func
};
PasswordField.defaultProps = {
  password: "",
  className: "",
  autoFocus: false,
  ariaInvalid: false,
  ariaDescribedby: "",
  myRef: ""
};
export default PasswordField;
